var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner"}),_c('div',{staticClass:"rate"},[_vm._v(_vm._s(_vm.loadingProgress))])])}
var staticRenderFns = []

export { render, staticRenderFns }